// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.badge {
  right: -3px !important;
  top: -3px !important;
  font-size: 10px !important;
}

.badge .badge-primary {
  background-color: #11212e;
  color: #ffffff;
}

.badge .badge-secondary {
  background-color: #41cbd8;
  color: #ffffff;
}

.badge .badge-success {
  background-color: #2ddab5;
  color: #ffffff;
}

.badge .badge-danger {
  background-color: #a82323;
  color: #ffffff;
}

.badge .badge-warning {
  background-color: #ff9f43;
  color: #ffffff;
}

.badge .badge-info {
  background-color: #9ba7ca;
  color: #ffffff;
}

.badge .badge-light {
  background-color: #f8f9fa;
  color: #000000;
}

.badge .badge-dark {
  background-color: #343a40;
  color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Badge/badge.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".badge {\n  right: -3px !important;\n  top: -3px !important;\n  font-size: 10px !important;\n}\n\n.badge .badge-primary {\n  background-color: #11212e;\n  color: #ffffff;\n}\n\n.badge .badge-secondary {\n  background-color: #41cbd8;\n  color: #ffffff;\n}\n\n.badge .badge-success {\n  background-color: #2ddab5;\n  color: #ffffff;\n}\n\n.badge .badge-danger {\n  background-color: #a82323;\n  color: #ffffff;\n}\n\n.badge .badge-warning {\n  background-color: #ff9f43;\n  color: #ffffff;\n}\n\n.badge .badge-info {\n  background-color: #9ba7ca;\n  color: #ffffff;\n}\n\n.badge .badge-light {\n  background-color: #f8f9fa;\n  color: #000000;\n}\n\n.badge .badge-dark {\n  background-color: #343a40;\n  color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
